export default __webpack_public_path__ + "static/media/zoom-out-disabled.6b9d20f1.svg";